import { HDSFeaturesContext } from './HDSFeaturesContext';
import { HDSThemeProvider } from './HDSThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export const HDSAppProvider = ({
  children,
  features = {
    nextThemeEnabled: false
  }
}) => {
  return /*#__PURE__*/_jsx(HDSFeaturesContext.Provider, {
    value: features,
    children: /*#__PURE__*/_jsx(HDSThemeProvider, {
      children: children
    })
  });
};